import React from "react";
import PropTypes from "prop-types";
import useTemplateManager from "../hooks/use-template-manager";

function WithTemplate(props) {

    const templateManager = useTemplateManager();

    const desiredTemplate = props.template || templateManager.defaultTemplate;

    const [shouldRender, setShouldRender] = React.useState(templateManager.isTemplate(desiredTemplate));

    React.useEffect(() => {
        if(!shouldRender) {
            templateManager.changeTemplate(desiredTemplate);
        }
    });

    if(!shouldRender) {
        return null;
    }

    return props.children;
}

WithTemplate.defaultProps = {
    template: null,
};

WithTemplate.propTypes = {
    template: PropTypes.string,
};

export default WithTemplate;
